export default __webpack_public_path__ + "static/B0033-8b84394d5d5aed8efac73c92dc8bd06d.png";